import React from 'react';

import { Box } from '@mui/material';

import logoNavbar from './assets/logo-navbar.svg';
import { BRIGHT_HONEY_DEW, BRIGHT_HONEY_DEW_HOVER, FONT_FAMILY, PRIMARY_GREEN } from './colors';

interface NavbarProps {
  contactUrl: string;
}

const Navbar = ({ contactUrl }: NavbarProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      maxWidth: '1152px',
      margin: '0 auto',
      padding: '40px 0'
    }}
  >
    <Box alt="Scout Talent" component="img" src={logoNavbar} sx={{ height: '25px' }} />
    <Box
      component="a"
      href={contactUrl}
      sx={{
        border: 'none',
        cursor: 'pointer',
        textDecoration: 'none',
        backgroundColor: BRIGHT_HONEY_DEW,
        color: PRIMARY_GREEN,
        fontFamily: FONT_FAMILY,
        fontWeight: 600,
        fontSize: '16px',
        borderRadius: '104px',
        padding: '16px 32px',
        transition: '0.3s',
        '&:hover, &:focus': { backgroundColor: BRIGHT_HONEY_DEW_HOVER }
      }}
    >
      Schedule a call
    </Box>
  </Box>
);

export default Navbar;
